import axios from 'axios'
const uri = 'consultas-facturacion/php/api/porClientes/'

const get = (url) => {
	return axios.get(uri + url)
}

const post = (url, datos) => {
	return axios.post(uri + url, datos)
}

export default {
	getFormulario () {
		return get('get-formulario.php')
	},

	consultar (datos) {
		const filtro = _.clone(datos)
		if (filtro.tipoFecha === 'intervalo') {
			filtro.fecha_ini = Math.floor(datos.fecha_ini.getTime() / 1000)
			filtro.fecha_fin = Math.floor(datos.fecha_fin.getTime() / 1000)
		} else {
			filtro.fecha_ini = new Date(datos.fecha_ini.getTime())
			filtro.fecha_ini.setMonth(0)
			filtro.fecha_ini.setDate(1)
			filtro.fecha_ini.setHours(0)
			filtro.fecha_ini.setMinutes(0)
			filtro.fecha_ini.setSeconds(0)
			filtro.fecha_ini.setMilliseconds(0)
			filtro.fecha_ini = Math.floor(filtro.fecha_ini.getTime() / 1000)

			filtro.fecha_fin = new Date(datos.fecha_fin.getTime())
			filtro.fecha_fin.setMonth(11)
			filtro.fecha_fin.setDate(31)
			filtro.fecha_fin.setHours(23)
			filtro.fecha_fin.setMinutes(59)
			filtro.fecha_fin.setSeconds(59)
			filtro.fecha_fin.setMilliseconds(999)
			filtro.fecha_fin = Math.floor(datos.fecha_fin.getTime() / 1000)
		}
		return post('consultar.php', filtro)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/consultas-facturacion/vue/components/porClientes/api.js